import React from 'react';
import { DeploymentCenter } from 'js/assessment';
import progressQuery from './progress.graphql';
import ShareLogo from '../../../images/SHARE-Logo.svg';

const DeploymentCenterPage = props => {
    return (
        <DeploymentCenter
            collectionBuckets={['Student', 'Caregiver', 'Educator', 'Mental Health Provider']}
            contactTypes={['Caregiver', 'Educator', 'Mental Health Provider']}
            logo={ShareLogo}
            progressQuery={progressQuery}
            addToCollectionButtonLabel="Add to Plan"
        />
    );
};

export default DeploymentCenterPage;
